import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c(VImg,{attrs:{"contain":"","eager":"","src":_vm.image}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }